import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Route, Redirect, Switch } from 'react-router-dom';
import {
  Page,
  PageBody,
  Link,
  TabsNav,
  TabsList,
  TabItem,
  H1,
  PageActions,
  PageHeader,
  PageTitle,
} from 'next/components/ui';
import { selectUserRole } from 'reducers/account/users';
import { selectUserId } from 'reducers/user';
import { ACCOUNT_PERMISSIONS } from 'constants/accountManagement/permissions';
import UserList from 'components/Audience/UserList';
import SegmentList from 'components/Audience/SegmentList';
import { ButtonLink } from './styled';

export const Audiences = ({ canCreateSegments, match: { url, path } }) => {
  return (
    <Page>
      <PageHeader>
        <PageTitle>
          <H1>Segments & Users</H1>
        </PageTitle>
        {canCreateSegments && (
          <Route
            path={`${path}/segments`}
            render={() => (
              <PageActions>
                <ButtonLink to="/segments/new/edit">
                  Create a Segment
                </ButtonLink>
              </PageActions>
            )}
          />
        )}
      </PageHeader>
      <TabsNav sticky>
        <TabsList>
          <Route path={`${path}/segments`}>
            {({ match }) => (
              <TabItem $active={match}>
                <Link to={`${url}/segments`}>Segments</Link>
              </TabItem>
            )}
          </Route>
          <Route path={`${path}/users`}>
            {({ match }) => (
              <TabItem $active={match}>
                <Link to={`${url}/users`}>Users</Link>
              </TabItem>
            )}
          </Route>
        </TabsList>
      </TabsNav>
      <PageBody>
        <Switch>
          <Route path={`${path}/segments`} component={SegmentList} />
          <Route path={`${path}/users`} component={UserList} />
          <Redirect to={`${path}/segments`} />
        </Switch>
      </PageBody>
    </Page>
  );
};

Audiences.propTypes = {
  match: PropTypes.shape({
    path: PropTypes.string,
  }),
  canCreateSegments: PropTypes.bool,
};

const mapStateToProps = state => ({
  canCreateSegments:
    selectUserRole(state, selectUserId(state)) !== ACCOUNT_PERMISSIONS.EDITOR,
});

export default connect(mapStateToProps)(Audiences);
